export default "__VITE_ASSET__CmwkaYmX__"